import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/modules/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

var version = require('../package.json').version; 
console.log('Version: ' + version); 

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
